<template>
  <section class="personal-center-panel">
    <h2>登录记录</h2>
    <p class="service-notice">这里只展示您自己的近期登录记录。如发现异常，请立即修改密码并检查科技云绑定。</p>
    <p v-if="loading" class="empty-state">正在加载...</p>
    <p v-else-if="error" class="service-notice warning">{{ error }}</p>
    <div v-else-if="records.length" class="login-record-list">
      <article v-for="(record, index) in records" :key="record.id || record.recordId || index">
        <div><strong>{{ sourceLabel(record.authSource || record.loginType) }}</strong><span :class="resultClass(record)">{{ resultLabel(record) }}</span></div>
        <p>{{ record.loginTime || record.createTime || '—' }}</p>
        <p>{{ record.device || [record.browser, record.os].filter(Boolean).join(' / ') || '未知设备' }}</p>
        <p>{{ record.ipLocation || record.loginLocation || record.ipMasked || '未知位置' }}</p>
      </article>
    </div>
    <p v-else class="empty-state">暂无登录记录</p>
    <div v-if="total > pageSize" class="login-record-pagination">
      <button type="button" class="ghost-action compact" :disabled="pageNum <= 1" @click="changePage(-1)">上一页</button>
      <span>第 {{ pageNum }} 页</span>
      <button type="button" class="ghost-action compact" :disabled="pageNum * pageSize >= total" @click="changePage(1)">下一页</button>
    </div>
  </section>
</template>

<script>
import { listMyLoginRecords } from '../../../api/paleo'

export default {
  name: 'LoginRecordsPanel',
  data() { return { loading: false, error: '', records: [], total: 0, pageNum: 1, pageSize: 10 } },
  created() { this.load() },
  methods: {
    async load() {
      this.loading = true; this.error = ''
      try {
        const result = await listMyLoginRecords({ pageNum: this.pageNum, pageSize: this.pageSize })
        const data = result.data || result || {}
        this.records = result.rows || data.rows || data.records || data.list || []
        this.total = Number(result.total != null ? result.total : (data.total != null ? data.total : this.records.length))
      } catch (error) { this.error = error.message || '登录记录加载失败' } finally { this.loading = false }
    },
    changePage(step) { this.pageNum += step; this.load() },
    sourceLabel(value) { return String(value || '').toUpperCase() === 'CSTCLOUD' ? '中国科技云' : '邮箱密码' },
    resultLabel(record) { const raw = record.result != null ? record.result : record.status; const value = String(raw == null ? '' : raw).toUpperCase(); return ['SUCCESS', '0'].includes(value) ? '成功' : '失败' },
    resultClass(record) { return this.resultLabel(record) === '成功' ? 'success' : 'failed' }
  }
}
</script>

<style scoped>
.login-record-list { display: grid; gap: .75rem; }
.login-record-list article { padding: 1rem; border: 1px solid #e2e8f0; border-radius: 10px; background: #fff; }
.login-record-list article > div { display: flex; justify-content: space-between; gap: 1rem; }
.login-record-list p { display: inline-block; margin: .55rem 1.2rem 0 0; color: #64748b; }
.success { color: #17643a; }.failed { color: #b42318; }
.login-record-pagination { display: flex; justify-content: center; align-items: center; gap: 1rem; margin-top: 1rem; }
</style>
